import { createFileRoute } from "@tanstack/react-router";
import { Clause, LegalLayout } from "@/components/sox/LegalLayout";
import { LEGAL, LEGAL_ADDRESS_LINE } from "@/lib/legal";

export const Route = createFileRoute("/legal-notice")({
  head: () => ({
    meta: [
      { title: "Legal Notice & Imprint — SOXIE365" },
      {
        name: "description",
        content:
          "Trader identity, registration and contact details for SOXIE365, as required by EU e-commerce and consumer information rules.",
      },
      { property: "og:title", content: "Legal Notice & Imprint — SOXIE365" },
      {
        property: "og:description",
        content: "Who operates SOXIE365, with full company and contact details.",
      },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary" },
      { property: "og:url", content: "https://www.soxie365.com/legal-notice" },
    ],
    links: [{ rel: "canonical", href: "https://www.soxie365.com/legal-notice" }],
  }),
  component: LegalNoticePage,
});

function LegalNoticePage() {
  return (
    <LegalLayout
      index="05"
      title="Legal Notice"
      intro="Trader information published under Article 5 of the EU e-Commerce Directive, the Consumer Rights Directive, and equivalent UK and US disclosure rules."
    >
      <Clause heading="1. Operator">
        <p>
          <strong>{LEGAL.entity}</strong> (trading as {LEGAL.tradingName})
          <br />
          {LEGAL_ADDRESS_LINE}
          <br />
          Company registration number: {LEGAL.registrationNumber}
          <br />
          VAT identification number: {LEGAL.vatNumber}
        </p>
        <p>
          Email: <a href={`mailto:${LEGAL.supportEmail}`}>{LEGAL.supportEmail}</a>
          <br />
          Website: <a href={LEGAL.site}>{LEGAL.domain}</a>
        </p>

      </Clause>

      <Clause heading="2. Responsible for content">
        <p>
          The management of {LEGAL.entity}, at the address above, is responsible for the content of
          this website.
        </p>
      </Clause>

      <Clause heading="3. Online dispute resolution">
        <p>
          The European Commission provides an ODR platform at{" "}
          <a href="https://ec.europa.eu/consumers/odr" rel="noopener noreferrer" target="_blank">
            ec.europa.eu/consumers/odr
          </a>
          . We are not obliged and not willing to take part in dispute resolution proceedings before
          a consumer arbitration board, but we handle every complaint sent to{" "}
          <a href={`mailto:${LEGAL.supportEmail}`}>{LEGAL.supportEmail}</a> directly and promptly.
        </p>
      </Clause>

      <Clause heading="4. Content and external links">
        <p>
          We prepare the content of this site with care but give no guarantee that it is complete,
          accurate or current. We are not responsible for the content of external sites we link to;
          responsibility lies with their operators.
        </p>
      </Clause>

      <Clause heading="5. Copyright">
        <p>
          All content, imagery, product photography and design on this site are protected by
          copyright and belong to {LEGAL.entity} unless stated otherwise. Reproduction, adaptation or
          distribution requires our written consent.
        </p>
      </Clause>

      <Clause heading="6. Accessibility">
        <p>
          We aim to meet WCAG 2.1 AA. If any part of this site is difficult to use with assistive
          technology, email <a href={`mailto:${LEGAL.supportEmail}`}>{LEGAL.supportEmail}</a> and we
          will fix it and provide the information you need in another format.
        </p>
      </Clause>
    </LegalLayout>
  );
}
